

























































import draggable from "vuedraggable";
import Slider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { Question, Vue } from "@/types.ts";

export default Vue.extend({
  name: "Question",
  components: {
    draggable,
    Slider,
  },
  computed: {
    range: {
      get(): [number, number] {
        return [this.question.min, this.question.max];
      },
      set([min, max]: [number, number]): void {
        this.question.min = min;
        this.question.max = max;
      },
    },
  },
  methods: {
    addAnswer() {
      this.question.answers.push("");
      this.$emit("input");
    },
    removeAnswer(i: number) {
      this.question.answers.splice(i, 1);
      this.question.max = Math.min(
        this.question.max,
        this.question.answers.length
      );
      this.$emit("input");
    },
  },
  props: {
    question: {
      type: Object as () => Question,
      required: true,
    },
  },
});
